<template>
  <div class="act-container">
    <div class="activity-box">
      <div class="content">
        <p class="desc">近期冠状病毒肆虐，明明城堡制作的两节动画课可以帮助孩子们更好地了解病毒的的危害和传播方式，以及人体如何对抗病毒。现在开放给大家，为抗击新型冠状病毒出一分力，希望我们齐心协力对抗病毒传播。</p>
        <div class="subjects">
          <div class="subject-item" v-for="(item, index) in subjects" :key="index">
            <div class="logo">
              <img :src="item.smallLogoImg" />
            </div>
            <div class="title">{{item.title}}</div>
            <div class="preview">
              <div class="preview-text" @click="navToSubject(item.id, item.title)">点击学习</div>
            </div>
          </div>
        </div>

        <h3 class="title-v2">如何预防病毒</h3>
        <div class="methods">
          <div class="method-two">
            <img :src="require('@/assets/virus/1@2x.png')" alt="">
          </div>
          <div class="method-two">
            <img :src="require('@/assets/virus/2@2x.png')" alt="">
          </div>
          <div class="method-one">
            <img :src="require('@/assets/virus/3@2x.png')" alt="" class="one">
          </div>
          <div class="method-two">
            <img :src="require('@/assets/virus/4@2x.png')" alt="">
          </div>
          <div class="method-two">
            <img :src="require('@/assets/virus/5@2x.png')" alt="">
          </div>
        </div>

        <div class="button-box" @click="moreSubjects">
          <div class="button-text">学习更多课程→</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityVirus',
  data() {
    return {
      subjects: [{
        id: 1,
        smallLogoImg: require('@/assets/virus/class-virus.png'),
        title: '流感病毒入侵'
      },
      {
        id: 2,
        smallLogoImg: require('@/assets/virus/class-body.png'),
        title: '呼吸大冒险'
      }]
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.setShare()
  },
  methods: {
    setShare() {
      // 设置分享
      this.wechatShare({
        title: `病毒肆虐，怎么告诉孩子保护自己？`,
        imgUrl: 'https://mmcb-act.oss-cn-hangzhou.aliyuncs.com/class-virus.png',
        desc: '讲给孩子关于病毒和呼吸系统的知识',
        link: `${window.location.origin}/#/activity/virus`
      })
    },
    moreSubjects() {
      // this.$zhuge.track('学习更多课程', {
      //   '课程名称': '人体大冒险'
      // })
      window.location.href = `${window.location.origin}/#/subject?id=4&scene=virus`
    },
    navToSubject(id, title) {
      // this.$zhuge.track('病毒专题-点击学习', {
      //   '课程ID': id,
      //   '课时标题': title
      // })
      window.location.href = `http://mmcb-act-cdn.mmcb.top/video/00${id}.html`
    }
  }
}
</script>

<style lang="scss">
html,body,#app {
  height: 100%;
}
.act-container {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  padding-bottom: 50px;
  background-image: url('~@/assets/virus/bg@2x.png');
  background-size: cover;

  .content{
    background: #4141F3;
    border-radius: 3px;
    margin: 190px 10px 0 10px;
    padding: 10px;
    p{
      color: #fff;
      font-size: 13px;
      line-height: 2em;
    }
    .desc{
      margin: 15px 0;
    }

    .subjects{
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;

      .subject-item {
        flex: 39%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 8px;
        background: #fff;
        border-radius: 5px;
        .logo {
          width: 100%;
          img {
            width: 100%;
          }
        }

        .title {
          display: inline-block;
          vertical-align: text-top;
          height: 18px;
          margin-top: 8px;
          font-size: 14px;
          text-align: center;
          color: #333;
        }
        .preview {
          height: 24px;
          width: 100%;
          margin: 8px 0 12px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url('~@/assets/images/preview_btn.png') no-repeat center center;
          background-size: contain;

          .preview-text {
            font-size: 12px;
            color: white;
          }
        }
      }
    }

    .title-v2{
      text-align: center;
      color: #fff;
      margin: 25px;
    }

    .methods{
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      margin-bottom: 50px;

      img{
        width: 100%;
      }

      .method-two{
        flex: 40%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 5px;
      }
      .method-one{
        flex: 100%;
        margin: 5px;
      }
    }
  }
}

.button-box {
  height: 40px;
  width: 90%;
  /*margin: 15px auto;*/
  position: fixed;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #4E7FFA;
  border-radius: 40px;

  .button-text {
    color: white;
    font-size: 16px;
  }
}
</style>
